export default __webpack_public_path__ + "static/media/target-3.b2e42070.png";